export enum PaginationItemType {
    NAVIGATION_BUTTON = "button",
    NAVIGATE_TO_FIRST_PAGE = "first",
    NAVIGATE_TO_LAST_PAGE = "last",
    NAVIGATE_TO_PREVIOUS_PAGE = "previous",
    NAVIGATE_TO_NEXT_PAGE = "next",
    SKIP_LABEL = "label"
}
